

import type { ApiCommand, ApiRequest } from './apiCommand';


export class GetAuthCookiesCommand implements ApiCommand<void> {
  constructor(private input: Record<string, never>) {
    void this.input;
  }

  request(): ApiRequest {
    return {
      linkName: 'cookies',
      pathParams: {},
      queryParams: {},
      method: 'GET',
      body: undefined,
    };
  }

  asOutput(body: unknown): void {
  }
}
